import type { ReactNode } from 'react';
import { Price } from '@artosera/ui';
import { useTranslation } from 'react-i18next';
import { useLangue } from '../../composants/useLangue.js';
import { useShellContext } from '../shell/context.js';
import { useSyntheseBoutique } from './donneesBoutique.js';
import styles from './BoutiquePage.module.css';
function Indicateur({
  libelle,
  valeur,
  aide,
  accent,
}: {
  libelle: string;
  valeur: ReactNode;
  aide: string;
  accent?: boolean;
}) {
  return (
    <div className={styles.indicateur} data-accent={accent ? 'true' : undefined}>
      <dt className={styles.indicateurLibelle}>{libelle}</dt>
      <dd className={styles.indicateurValeur}>{valeur}</dd>
      <dd className={styles.indicateurAide}>{aide}</dd>
    </div>
  );
}
/** Quatre chiffres en tête de page, tirés des listes de l'API ; « — » tant qu'ils ne sont pas connus. */
export function IndicateursBoutique() {
  const { t } = useTranslation('regie');
  const { galerieSlug } = useShellContext();
  const langue = useLangue();
  const synthese = useSyntheseBoutique(galerieSlug);
  const nombre = (n: number | undefined) => (n === undefined ? '—' : n);
  return (
    <section aria-labelledby="boutique-synthese">
      <h2 id="boutique-synthese" className={styles.titreSynthese}>
        {t('boutique.synthese.titre')}
      </h2>
      <dl className={styles.indicateurs} aria-busy={synthese.chargement || undefined}>
        <Indicateur
          libelle={t('boutique.synthese.oeuvresEnVente')}
          valeur={nombre(synthese.nbOeuvresEnVente)}
          aide={t('boutique.synthese.oeuvresEnVenteAide')}
        />
        <Indicateur
          libelle={t('boutique.synthese.aTraiter')}
          valeur={nombre(synthese.nbATraiter)}
          aide={t('boutique.synthese.aTraiterAide')}
          accent={!!synthese.nbATraiter}
        />
        <Indicateur
          libelle={t('boutique.synthese.chiffreMois')}
          valeur={synthese.mois ? <Price cents={synthese.mois.centimes} lang={langue} /> : '—'}
          aide={
            synthese.mois
              ? t('boutique.synthese.chiffre', { count: synthese.mois.nombre }) +
                (synthese.moisPartiel
                  ? ` ${t('boutique.synthese.chiffrePartiel', { count: 200 })}`
                  : '')
              : ''
          }
        />
        <Indicateur
          libelle={t('boutique.synthese.remboursements')}
          valeur={nombre(synthese.nbARembourser)}
          aide={t('boutique.synthese.remboursementsAide')}
          accent={!!synthese.nbARembourser}
        />
      </dl>
    </section>
  );
}
